/**
 * 功能: slide页面组件框架
 */
<template lang="pug">
  div.aside-menu.clearfix
    div(style="line-height: 2; margin:10px 0" v-if="data.parent")
      div.clearfix.fl
        h4(style="padding-right: 10px") {{ data.wbs }} {{ data.name }}
      Slide(:data="data" v-bind="$attrs" v-on="$listeners")
    template(v-for="child in data.children")
      Thumbnail(:key="child.wbs" :data="child")
</template>

<script>
import Slide from './slide'
// import api from '@/apis/slide'

export default {
  name: 'Thumbnail',
  components: { Slide },
  inheritAttrs: false,
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  inject: ['reload'],
  data () {
    return {
      select: {},
      outline: {}
    }
  },
  methods: {
    handleRemove (file) {
    },
    reloadImage () {
      this.reload()
    }
    // // 删除
    // removeSlide () {}
  }
}
</script>
<style>
.aside-menu {
  width: 230px;
  font-size: 14px;
  color: black;
  padding-right: 15px;
}
</style>
